/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import _ from 'underscore';

import { Analytics } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { getKey, Key } from '@trello/keybindings';
import { getScreenFromUrl } from '@trello/marketing-screens';
import { TrelloStorage } from '@trello/storage';

import { Auth } from 'app/scripts/db/Auth';
import { ModelCache } from 'app/scripts/db/ModelCache';
import { l } from 'app/scripts/lib/localize';
import { Util } from 'app/scripts/lib/util';
import { searchFilter } from 'app/scripts/lib/util/text/search-filter';
import { templates } from 'app/scripts/views/internal/templates';
import type { ViewOptions } from 'app/scripts/views/internal/View';
import { View } from 'app/scripts/views/internal/View';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { SelectFilterableView } from 'app/scripts/views/member/SelectFilterableView';
import { SelectMemberView } from 'app/scripts/views/member/SelectMemberView';
import { PopoverAutoMentionerTemplate } from 'app/scripts/views/templates/PopoverAutoMentionerTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

const RECENT_MENTIONS_KEY = 'recentMentions';
// eslint-disable-next-line @trello/no-module-logic
let recentMentions = TrelloStorage.get(RECENT_MENTIONS_KEY) || [];
interface AutoMentionerView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $mentionablesList: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  appendSubviews: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  board: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  card: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setTimeout: any;
}

class AutoMentionerView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'mention';

    this.prototype.events = {
      // @ts-expect-error
      'mouseenter .js-select-member': 'hoverItem',
      'click .js-select-member:not(.disabled)': 'insertMember',
      'mouseenter .js-select-all-card-members': 'deselectMember',
      'mouseenter .js-select-all-board-members': 'deselectMember',
      keydown: 'keydownEvent',
      'keyup .js-filter-mentionables': 'keyupEvent',
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialize({ board, card }: any) {
    let org;
    this.board = board;
    this.card = card;
    if ((org = this.board != null ? this.board.getOrganization() : undefined)) {
      return this.listenTo(
        org.memberList,
        'add remove reset',
        this.frameDebounce(this.render),
      );
    }
  }

  render() {
    const data = {};
    if (this.options.input) {
      // @ts-expect-error TS(2339): Property 'input' does not exist on type '{}'.
      data.input = true;
    }
    if (this.options.button) {
      // @ts-expect-error TS(2339): Property 'button' does not exist on type '{}'.
      data.button = true;
    }

    this.$el.html(templates.fill(PopoverAutoMentionerTemplate, data));

    Analytics.sendScreenEvent({
      name: 'mentionMembersInlineDialog',
      containers: {
        card: {
          id: this.card != null ? this.card.id : undefined,
        },
        board: {
          id: this.board != null ? this.board.id : undefined,
        },
      },
    });

    this.$mentionablesList = $('.js-available-members', this.$el);

    if (this.options.button) {
      this.fillMentionables(this.getMentionables());
    } else if (this.options.input) {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      this.filterMentionables();
    }

    return this;
  }

  getTextInput() {
    // @ts-expect-error TS(2769): Argument of type 'unknown' is not assignable to parameter of type 'PlainObject<any>'.
    return $(this.options.target);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getExtraMentionables(cardMentionables: any, boardMentionables: any) {
    const allCardMentionable = {
      type: 'extra',
      text: 'card',
      names: ['all', 'card'],
      extraText: l(['automentioner', 'all-members-on-card']),
      mentionCount: cardMentionables.length,
    };
    const allBoardMentionable = {
      type: 'extra',
      text: 'board',
      names: ['all', 'board'],
      extraText: l(['automentioner', 'all-members-on-board']),
      mentionCount: boardMentionables.length,
    };

    if (this.card != null) {
      return [allCardMentionable, allBoardMentionable];
    }
    return [allBoardMentionable];
  }

  getMentionables() {
    const myId = Auth.myId();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const idsToMentionables = (ids: any, options: any) => {
      if (options == null) {
        options = {};
      }
      return _.chain(ids)
        .reject((id) => {
          return this.board.isDeactivated(ModelCache.get('Member', id));
        })
        .map((id) => {
          return {
            ...options,
            id,
            names: Util.getMemNameArrayFromId(this.modelCache, id),
            type: 'member',
          };
        })
        .value();
    };

    // Sort mentions by recency, unless it's yourself
    // We allow self-mentioning, but always push yourself to the
    // bottom of the list
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sortMentionables = function (mentionable: any, iter: any, list: any) {
      const index = recentMentions.indexOf(mentionable.id);
      if (mentionable.id === myId) {
        return list.length;
      } else if (index === -1) {
        return recentMentions.length;
      } else {
        return index;
      }
    };

    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    const cardMentionables = idsToMentionables(
      this.card != null ? this.card.getIdCardMems() : undefined,
    );
    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    const boardMentionables = idsToMentionables(this.board.getIdBoardMems());

    const orgMentionables = (() => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let org: any;
      if ((org = this.board.getOrganization()) != null) {
        let idValidMembers = [];
        let idInvalidMembers = [];

        const activeMembers = org.memberList.filter(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (member: any) => !org.isDeactivated(member),
        );

        if (this.board.isPrivate()) {
          if (org.hasPremiumFeature('superAdmins')) {
            const membersByMemberType = _.groupBy(activeMembers, (member) => {
              if (org.ownedByMember(member)) {
                return 'admin';
              } else {
                return 'not-admin';
              }
            });

            // @ts-expect-error TS(2345): Argument of type 'unknown[]' is not assignable to ... Remove this comment to see the full error message
            idValidMembers = _.pluck(membersByMemberType['admin'], 'id');
            // @ts-expect-error TS(2345): Argument of type 'unknown[]' is not assignable to ... Remove this comment to see the full error message
            idInvalidMembers = _.pluck(membersByMemberType['non-admin'], 'id');
          } else {
            idInvalidMembers = _.pluck(activeMembers, 'id');
          }
        } else {
          idValidMembers = _.pluck(activeMembers, 'id');
        }

        return [
          // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
          ...Array.from(idsToMentionables(idValidMembers)),
          ...Array.from(
            idsToMentionables(idInvalidMembers, {
              disabled: true,
              extraText: l(['mention member', 'board not team visible']),
            }),
          ),
        ];
      } else {
        return [];
      }
    })();

    return _.chain([
      ...Array.from(cardMentionables),
      ...Array.from(boardMentionables),
      ...Array.from(orgMentionables),
    ])
      .uniq((mentionable) => mentionable.id)
      .sortBy(sortMentionables)
      .concat(this.getExtraMentionables(cardMentionables, boardMentionables))
      .value();
  }

  clearMentionables() {
    return this.$mentionablesList.empty();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keydownEvent(e: any) {
    let needle;
    if (((needle = getKey(e)), [Key.Enter, Key.Tab].includes(needle))) {
      stopPropagationAndPreventDefault(e);
      this.$mentionablesList
        .find('.item.selected:first .js-select-member')
        .click();
      return;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keyupEvent(e: any) {
    const key = getKey(e);

    if ([Key.Enter, Key.Tab, Key.ArrowLeft, Key.ArrowRight].includes(key)) {
      return;
    } else if ([Key.ArrowUp, Key.ArrowDown].includes(key)) {
      stopPropagationAndPreventDefault(e);
      Util.navMenuList(this.$mentionablesList, '.item', key);
      return;
    } else {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      return this.filterMentionables();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterMentionables(e: any) {
    let term;
    this.clearMentionables();

    if (this.options.button) {
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      term = $('.js-filter-mentionables').val().trim().toLowerCase();
    } else if (this.options.input) {
      // eslint-disable-next-line @trello/enforce-variable-case
      const $textInput = this.getTextInput();
      const word = Util.getWordFromCaret($textInput);
      term = word.str.substring(1).toLowerCase();
    }

    const matches = this.filterMentionablesForMatches(term);

    // hide if there are no results
    if (this.options.input && matches.length === 0) {
      this.setTimeout(() => PopOver.hide(), 5);
      return;
    }

    this.fillMentionables(matches);
    return Util.selectMenuItem(
      this.$mentionablesList,
      '.item',
      this.$mentionablesList.find('.item').first(),
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterMentionablesForMatches(term: any) {
    const satisfiesSearch = searchFilter(term);

    return _.filter(this.getMentionables(), (filterable) =>
      satisfiesSearch(filterable.names),
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hoverItem(e: any) {
    // eslint-disable-next-line @trello/enforce-variable-case
    const $elem = $(e.target).closest('.item');
    return Util.selectMenuItem(this.$mentionablesList, '.item', $elem);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  deselectMember(e: any) {
    return this.$mentionablesList.find('.item').removeClass('selected');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fillMentionables(filterables: any) {
    filterables = _.groupBy(filterables, 'type');

    const entries = (filterables.member || [])
      .slice(0, 50)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .map(({ id, disabled, extraText }: any) => {
        return {
          member: ModelCache.get('Member', id),
          disabled,
          extraText,
        };
      });

    this.$mentionablesList.empty();

    const mentionables = [];
    // @ts-expect-error TS(2339): Property 'member' does not exist on type 'unknown'... Remove this comment to see the full error message
    for (const { member, disabled, extraText } of Array.from(entries)) {
      mentionables.push(
        this.subview(SelectMemberView, member, { disabled, extraText }),
      );
    }
    this.appendSubviews(mentionables, this.$mentionablesList);

    if (filterables.extra != null) {
      for (const extra of Array.from(filterables.extra)) {
        this.$mentionablesList.append(
          new SelectFilterableView(extra as ViewOptions).render().el,
        );
      }
    }

    $('.js-empty-list', this.$el).toggleClass(
      'hide',
      _.keys(filterables).length > 0,
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  insertMember(e: any) {
    let word;
    stopPropagationAndPreventDefault(e);

    const autocompleteText = $(e.currentTarget).attr('autocompleteText');

    this.saveRecent($(e.currentTarget).attr('idMember'));

    let actionSubject = 'member';
    let actionSubjectId = $(e.currentTarget).attr('idMember');
    let source = getScreenFromUrl();

    if (autocompleteText === 'board') {
      actionSubject = 'board';
      actionSubjectId = this.board != null ? this.board.id : undefined;
      // if the mention is coming from the board screen,
      // it's coming from the Description box in the boards menu
      // via description-view.js
      if (source === 'boardScreen') {
        source = 'boardMenuDrawerAboutScreen';
      }
    }

    if (autocompleteText === 'card') {
      actionSubject = 'card';
      actionSubjectId = this.card != null ? this.card.id : undefined;
    }

    Analytics.sendTrackEvent({
      action: 'mentioned',
      // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'ActionSub... Remove this comment to see the full error message
      actionSubject,
      actionSubjectId,
      source,
      containers: {
        card: {
          id: this.card != null ? this.card.id : undefined,
        },
        board: {
          id: this.board != null ? this.board.id : undefined,
        },
      },
    });

    // eslint-disable-next-line @trello/enforce-variable-case
    const $textInput = this.getTextInput();
    if (this.options.input) {
      word = Util.getWordFromCaret($textInput);
      Util.insertSelection(
        $textInput,
        `@${autocompleteText} `,
        word.start,
        word.end,
      );
    } else {
      const caretPosition = Util.getCaretPosition($textInput);
      if (caretPosition != null) {
        word = {
          start: caretPosition,
          end: caretPosition,
        };
      }

      Util.insertSelection(
        $textInput,
        `@${autocompleteText} `,
        word != null ? word.start : undefined,
        word != null ? word.end : undefined,
      );
    }
    PopOver.hide();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  saveRecent(idMember: any) {
    let recent = TrelloStorage.get(RECENT_MENTIONS_KEY) || [];
    recent = _.chain([idMember, ...Array.from(recent)])
      .uniq()
      .first(16)
      .value();
    TrelloStorage.set(RECENT_MENTIONS_KEY, recent);
    return (recentMentions = recent);
  }
}

AutoMentionerView.initClass();
export { AutoMentionerView };
